import { render } from "./PaasLinkButton.vue?vue&type=template&id=35c7a5ff"
import script from "./PaasLinkButton.vue?vue&type=script&lang=js"
export * from "./PaasLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__